export default [
  {
    header: 'Logs',
    resource: 'MailLog',
    action: 'read',
  },
  {
    title: 'Mail Log',
    icon: 'MailIcon',
    route: 'mail-log-list',
    resource: 'MailLog',
    action: 'read',
  },
  {
    // คำค้นไหนทำให้ระบบต้องเรียกโมเดล AI (อ่านจาก logs/anthropic-usage.log)
    title: 'AI Keyword Log',
    icon: 'CpuIcon',
    route: 'ai-usage-keywords',
    resource: 'MailLog',
    action: 'read',
  },
]
